import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  notifications: {
    display: "flex",
    justifyContent: "space-between",
    height: "80%",
    width: "90%",
    position: "absolute",
  },
  notificationsForm: {
    height: "100%",
    width: "48%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  inputsForm: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    margin: "10px",
  },
  actionButton: {
    width: "40%",
    margin: "10px",
  },
  cellPhone: {
    position: "relative",
    display: "inline-block",
  },
  notificationPaper: {
    top: "0px",
    width: "358px",
    height: "70px",
    position: "absolute",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "67px",
    paddingTop: "5px",
    paddingLeft: "12px",
    paddingRight: "12px",
    paddinBottom: "10px",
    left: 0,
    right: 0,
  },
  notificationExpandedPaper: {
    top: "0px",
    width: "358px",
    height: "110px",
    position: "absolute",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "67px",
    paddingTop: "5px",
    paddingLeft: "12px",
    paddingRight: "12px",
    paddinBottom: "10px",
    left: 0,
    right: 0,
  },
  titleExpanded: {
    fontWeight: "bold",
    fontSize: "13px",
    textAlign: "left",
  },
  bodyExpanded: {
    fontSize: "13px",
    textAlign: "left",
  },
  titleInitial: {
    fontWeight: "bold",
    fontSize: "13px",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  bodyInitial: {
    fontSize: "13px",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  link: {
    color: "blue",
    fontSize: "10px",
    textAlign: "left",
    textDecoration: "underline blue",
    marginLeft: "5px",
  },
  rowLink: {
    display: "flex",
    fontSize: "10px",
    textAlign: "left",
  },
  text: {
    width: "80%",
    overflow: "hidden",
  },
  image: {
    height: "40px",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
  inputRow: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "flex-end",
    alignContent: "center",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  inputImage: {
    display: "none",
  },
}));

export default style;
